import React from 'react';
import { GridItem } from '../../components/layout/Grid';
import CampoRadio from '../../components/Formulario/CampoRadio';
import CampoMultiSeletor from '../../components/Formulario/CampoMultiSeletor';
import { useQuery } from 'react-query';
import axios from 'axios';
import AlertBox from '@/components/layout/AlertBox';

interface ConfiguracaoVisibilidadeGrupoProps {
  value: any;
  onChange: any;
  fieldErrors?: any;
}

export const ConfiguracaoVisibilidadeGrupo: React.FC<ConfiguracaoVisibilidadeGrupoProps> = ({
  value,
  onChange,
  fieldErrors
}) => {
  const modoVisibilidade = value?.modo_visibilidade ?? 'permitir_todos';
  const gruposVisibilidadeIds = value?.grupos_visibilidade_ids ?? [];

  // Buscar lista de grupos disponíveis
  const { data: grupos } = useQuery(['usuario_grupo'], async () => {
    const response = await axios.get('/api/usuario_grupo/box');
    return response.data;
  });

  const gruposOptions = grupos?.result
    ?.filter((g: any) => g.id !== value?.id) // Não mostrar o próprio grupo
    ?.map((g: any) => ({
      id: String(g.id),
      label: g.nome
    })) ?? [];

  const modoOptions = [
    { id: 'permitir_todos', label: 'Permitir todos os grupos visualizarem conversas deste grupo' },
    { id: 'lista_permitidos', label: 'Permitir apenas grupos selecionados (whitelist)' },
    { id: 'lista_bloqueados', label: 'Bloquear apenas grupos selecionados (blacklist)' }
  ];

  return (
    <>
      <GridItem sm={12}>
        <AlertBox
          variant="info"
        >
          <p>Configure quais grupos podem visualizar as conversas atendidas por este grupo ou seus atendentes.</p>
        </AlertBox>
      </GridItem>

      <GridItem sm={12}>
        {modoOptions.map(o => (
          <CampoRadio
            key={o.id}
            id={`modo_visibilidade_${o.id}`}
            label={o.label}
            name="modo_visibilidade"
            value={o.id}
            checked={modoVisibilidade === o.id}
            onChange={(v) => onChange({
              ...value,
              modo_visibilidade: v,
              // Limpar lista se voltar para "permitir_todos"
              grupos_visibilidade_ids: v === 'permitir_todos' ? [] : gruposVisibilidadeIds
            })}
            error={fieldErrors?.modo_visibilidade}
          />
        ))}
      </GridItem>

      {modoVisibilidade !== 'permitir_todos' && (
        <GridItem sm={12}>
          <CampoMultiSeletor
            instanceId="grupos_visibilidade_ids"
            label={
              modoVisibilidade === 'lista_permitidos'
                ? 'Grupos permitidos'
                : 'Grupos bloqueados'
            }
            options={gruposOptions}
            value={gruposVisibilidadeIds.map(String)}
            onChange={(ids: string[]) =>
              onChange({
                ...value,
                grupos_visibilidade_ids: ids?.map(Number)
              })
            }

            error={fieldErrors?.grupos_visibilidade_ids}
            placeholder={
              modoVisibilidade === 'lista_permitidos'
                ? 'Selecione os grupos que podem visualizar...'
                : 'Selecione os grupos que NÃO podem visualizar...'
            }
          />
        </GridItem>
      )}
    </>
  );
};
